/**
 * FAQ Section
 * Использует переиспользуемые компоненты
 * Примечание: использует useState для аккордеона в редакторе
 */
import React, { useState } from 'react';
import { Text, Icon } from '../components';

const maxWidthClasses = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-6xl',
};

export default function FAQ({ data, styles }) {
  const [openItems, setOpenItems] = useState({});
  const items = data?.items || [];
  const maxWidth = data?.maxWidth || 'md';

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <section
      style={{
        paddingTop: styles?.paddingTop ?? 64,
        paddingBottom: styles?.paddingBottom ?? 64,
        backgroundColor: styles?.backgroundColor || '#FFFFFF'
      }}
    >
      <div className={`${maxWidthClasses[maxWidth] || maxWidthClasses.md} mx-auto px-4`}>
        {/* Заголовок */}
        <Text
          as="h2"
          data={typeof data?.title === 'object' ? data.title : { text: data?.title }}
          defaults={{ size: '3xl', weight: 'bold', color: 'foreground' }}
          align="center"
          className="mb-4"
        />

        {/* Подзаголовок */}
        <Text
          as="p"
          data={typeof data?.subtitle === 'object' ? data.subtitle : { text: data?.subtitle }}
          defaults={{ size: 'base', weight: 'normal', color: 'text-secondary' }}
          align="center"
          className="mb-8 max-w-2xl mx-auto"
        />

        <div className="space-y-3">
          {items.map((item) => {
            const isOpen = openItems[item.id];
            return (
              <div
                key={item.id}
                className="border border-border rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleItem(item.id)}
                  className="w-full flex items-center justify-between p-4 text-left bg-card hover:bg-muted/50 transition-colors"
                >
                  <Text
                    as="span"
                    data={typeof item.question === 'object' ? item.question : { text: item.question }}
                    defaults={{ size: 'base', weight: 'medium', color: 'foreground' }}
                    className="pr-4"
                  />
                  <Icon
                    name={isOpen ? 'ChevronUp' : 'ChevronDown'}
                    size="md"
                    color="secondary"
                    className="flex-shrink-0"
                  />
                </button>
                <div
                  className={`px-4 pb-4 bg-card ${isOpen ? '' : 'hidden'}`}
                  data-faq-content={item.id}
                >
                  <Text
                    as="p"
                    data={typeof item.answer === 'object' ? item.answer : { text: item.answer }}
                    defaults={{ size: 'base', weight: 'normal', color: 'text-secondary' }}
                    className="whitespace-pre-wrap"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
